import Vue from 'vue';
export default new Vue();


// WEBPACK FOOTER //
// ./src/common/common-methods/eventBus.js